import React from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { AdminAuthProvider } from './context/AdminAuthContext';
import AdminProtectedRoute from './auth/AdminProtectedRoute';

// Sesiones
import VideoAsignacion from './pages/VideoAsignacion';
import VideoList from './pages/VideoList';
import EvaluacionList from './pages/EvaluacionList';
import CommentsList from './pages/CommentsList';
import CommentsDetail from './pages/CommentsDetail';

// Champions
import ChampionsList from './pages/ChampionsList';
import ChampionsDetail from './pages/ChampionsDetail';
import ChampionsAsignacion from './pages/ChampionsAsignacion';
import ChampionsParticipantes from './pages/ChampionsParticipantes';


// User & Disty
import UserList from './pages/UserList';
import Experts from './components/Experts';
import ConfigDistribuidor from './pages/ConfigDistribuidor';

import UsuariosSuperLider from './components/Usuarios/UsuariosSuperLider';
import AccesoSuperLider from './components/Usuarios/AccesoSuperLider';
import SesionesSuperLider from './components/Sesiones/SesionesSuperLider';
import NoticiasSuperLider from './components/Noticias/NoticiasSuperLider';

// Personalizar Sitio
import SliderList from './pages/SliderList';
import CintilloList from './pages/CintilloList';
import CarruselList from './pages/CarruselList';
import PopupList from './pages/PopupList';
import HomeConfigPanel from './pages/HomeConfigPanel';

import Home from './pages/Home';
import Login from './pages/Login';

function App() {
  return (
    <div className="App">
      <AdminAuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public */}
            <Route path="/login" element={<Login />} />

            {/* Protected */}
            <Route path="/" element={<AdminProtectedRoute><Home /></AdminProtectedRoute>} />

            {/* Temporada */}

            {/* Sesiones */}
            <Route path="/asignacion-sesiones" element={<AdminProtectedRoute><VideoAsignacion /></AdminProtectedRoute>} />
            <Route path="/listado-videos" element={<AdminProtectedRoute><VideoList /></AdminProtectedRoute>} />
            <Route path="/listado-evaluaciones" element={<AdminProtectedRoute><EvaluacionList /></AdminProtectedRoute>} />
            <Route path="/listado-comentarios" element={<AdminProtectedRoute><CommentsList /></AdminProtectedRoute>} />
            <Route path="/listado-comentarios/:videoId" element={<AdminProtectedRoute><CommentsDetail  /></AdminProtectedRoute>} />

             {/* Champions */}
            <Route path="/asignacion-champions" element={<AdminProtectedRoute><ChampionsAsignacion /></AdminProtectedRoute>} />
            <Route path="/listado-desafios" element={<AdminProtectedRoute><ChampionsList /></AdminProtectedRoute>} />
            <Route path="/champions/desafios/:id" element={<AdminProtectedRoute><ChampionsDetail /></AdminProtectedRoute>} />
            <Route path="/champions/participantes/:registroId" element={<AdminProtectedRoute><ChampionsParticipantes /></AdminProtectedRoute>} />
            
            

            {/* User & Disty */}
            <Route path="/config-distribuidor" element={<AdminProtectedRoute><ConfigDistribuidor /></AdminProtectedRoute>} />
            <Route path="/listado-expertos" element={<AdminProtectedRoute><Experts /></AdminProtectedRoute>} />
            <Route path="/listado-usuarios" element={<AdminProtectedRoute><UserList /></AdminProtectedRoute>} />

            <Route path="/usuarios" element={<AdminProtectedRoute><UsuariosSuperLider /></AdminProtectedRoute>} />
            <Route path="/carga-usuarios" element={<AdminProtectedRoute><UserList /></AdminProtectedRoute>} />
            <Route path="/control-acceso" element={<AdminProtectedRoute><AccesoSuperLider /></AdminProtectedRoute>} />
            <Route path="/sesiones" element={<AdminProtectedRoute><SesionesSuperLider /></AdminProtectedRoute>} />
            <Route path="/noticias" element={<AdminProtectedRoute><NoticiasSuperLider /></AdminProtectedRoute>} />


            {/* <Route path="/listado" element={<AdminProtectedRoute><UserList /></AdminProtectedRoute>}>
              <Route path="usuarios" element={<Users />} />
              <Route path="expertos" element={<Experts />} />
            </Route> */}

            {/* Personalizar Sitio */}
            <Route path="/listado-slider" element={<AdminProtectedRoute><SliderList /></AdminProtectedRoute>} />
            <Route path="/listado-avisos" element={<AdminProtectedRoute><CintilloList /></AdminProtectedRoute>} />
            <Route path="/listado-carrusel" element={<AdminProtectedRoute><CarruselList /></AdminProtectedRoute>} />
            <Route path="/listado-pop-ups" element={<AdminProtectedRoute><PopupList /></AdminProtectedRoute>} />
            <Route path="/switch-home" element={<AdminProtectedRoute><HomeConfigPanel /></AdminProtectedRoute>} />


          </Routes>
        </BrowserRouter>
      </AdminAuthProvider>
    </div>
  );
}

export default App;
